import { observable, action } from 'mobx'

class PurchaseOrderStore {
    @observable
    updateSatus: boolean = false

    @action
    setUpdateStatus() {
        this.updateSatus = !this.updateSatus
    }
}

export const purchaseOrderStore = new PurchaseOrderStore()
